/**
 * Utility functions for processing reward mappings data
 */

/**
 * Calculate the count of unique campaign IDs across all reward mappings
 * @param {Array} rewardMappings - Array of reward mapping objects
 * @returns {number} Count of unique campaign IDs
 */
export const getUniqueCampaignCount = (rewardMappings) => {
  if (!rewardMappings?.length) return 0;

  const uniqueCampaigns = rewardMappings.reduce((unique, mapping) => {
    if (mapping?.campaignIds?.length) {
      mapping.campaignIds.forEach((campaignId) => {
        if (campaignId && !unique.includes(campaignId)) {
          unique.push(campaignId);
        }
      });
    }
    return unique;
  }, []);

  return uniqueCampaigns.length;
};

/**
 * Calculate the count of unique reward IDs across all reward mappings
 * @param {Array} rewardMappings - Array of reward mapping objects
 * @returns {number} Count of unique reward IDs
 */
export const getUniqueRewardCount = (rewardMappings) => {
  if (!rewardMappings?.length) return 0;

  const uniqueRewards = rewardMappings.reduce((unique, mapping) => {
    if (mapping?.rewardId && !unique.includes(mapping.rewardId)) {
      unique.push(mapping.rewardId);
    }
    return unique;
  }, []);

  return uniqueRewards.length;
};

/**
 * Extract all unique campaign IDs from reward mappings
 * @param {Array} rewardMappings - Array of reward mapping objects
 * @returns {Array} Array of unique campaign IDs
 */
export const getUniqueCampaignIds = (rewardMappings) => {
  if (!rewardMappings?.length) return [];

  return rewardMappings.reduce((unique, mapping) => {
    if (mapping?.campaignIds?.length) {
      mapping.campaignIds.forEach((campaignId) => {
        if (campaignId && !unique.includes(campaignId)) {
          unique.push(campaignId);
        }
      });
    }
    return unique;
  }, []);
};

/**
 * Extract all unique reward IDs from reward mappings
 * @param {Array} rewardMappings - Array of reward mapping objects
 * @returns {Array} Array of unique reward IDs
 */
export const getUniqueRewardIds = (rewardMappings) => {
  if (!rewardMappings?.length) return [];

  return rewardMappings.reduce((unique, mapping) => {
    if (mapping?.rewardId && !unique.includes(mapping.rewardId)) {
      unique.push(mapping.rewardId);
    }
    return unique;
  }, []);
};
